<template>

<div>
  <p>Un bâtiment est qualifié de «&nbsp;traversant&nbsp;» lorsqu’il dispose d’ouvertures vitrées sur au moins deux façades d’orientation différente.</p>
</div>


</template>